// Internal Import
import { rootReducer } from './rootReducer';

// External Import
import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';

export const store = createStore(rootReducer, applyMiddleware(thunk));